import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import {
    addShareHolder,
    updateShareHolder,
    getShareHolders
} from "../../../../Utility/Api";
import { WarehouseContext } from "../../../../Utility/UserContext";

const AddShareHolderForm = ({ data, closeModal, refreshList }) => {
    const { showLoader, hideLoader, shopItem, UserItem } =
        useContext(WarehouseContext);

    const [parents, setParents] = useState([]);
    const [allShareHolders, setAllShareHolders] = useState([]);


    const [form, setForm] = useState({
        name: data?.name || "",
        phone: data?.phone || "",
        equity: data?.equity || "",
        capital: data?.capital || "",
        remarks: data?.remarks || "",
        parent_id: data?.parent_id || ""
    });


    useEffect(() => {
        fetchParents();
    }, []);

    const fetchParents = async () => {
        try {
            const params = {
                shop_id: shopItem?.shop_id || "",
            };
            const res = await getShareHolders(params);
            const list = res?.data?.data || [];
            setAllShareHolders(list);

            const onlyParents = res?.data?.data?.filter(
                item => !item.parent_id
            );
            setParents(onlyParents || []);
        } catch (err) {
            toast.error("Failed to load parent shareholders");
        }
    };

    const getRemainingParentEquity = (parentId) => {
        if (!parentId) return 100;

        const parent = allShareHolders.find(p => p.id == parentId);
        if (!parent) return 0;

        const parentEquity = Number(parent.equity || 0);

        // sum of existing children equity
        const usedEquity = allShareHolders
            .filter(c => c.parent_id == parentId && c.id !== data?.id)
            .reduce((sum, c) => sum + Number(c.equity || 0), 0);

        return parentEquity - usedEquity;
    };



    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.name || !form.phone || !form.equity) {
            toast.error("Fill all required fields");
            return;
        }

        showLoader();
        try {
            const payload = {
                name: form.name,
                phone: form.phone,
                equity: form.equity,
                capital: form.capital,
                remarks: form.remarks,
                parent_id: form.parent_id || null,
                created_by: UserItem?.user_id,
                shop_id: shopItem?.shop_id,
                status: "0"
            };

            if (data) {
                await updateShareHolder(data.id, payload);
                toast.success("Shareholder updated");
            } else {
                await addShareHolder(payload);
                toast.success("Shareholder added");
            }

            closeModal();
            refreshList();
        } catch (error) {
            const msg = error?.response?.data?.message;

            if (msg?.toLowerCase().includes("equity")) {
                toast.warning(msg);
              } else {
                toast.error(msg || "Something went wrong");
              }
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-md modal-dialog-centered">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title">
                            {data ? "Edit Share Holder" : "Add Share Holder"}
                        </h5>
                        <button className="btn-close" onClick={closeModal}></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">

                            {/* Parent / Child */}
                            <div className="mb-3">
                                <label className="form-label fw-semibold">
                                    Shareholder Type
                                </label>
                                <div className="mb-3">
                                    <label className="form-label">
                                        Select Parent
                                    </label>
                                    <select
                                        className="form-control"
                                        value={form.parent_id}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                parent_id: e.target.value
                                            })
                                        }
                                    // required
                                    >
                                        <option value="">
                                            Select Parent Shareholder
                                        </option>
                                        {parents.map(p => (
                                            <option key={p.id} value={p.id}>
                                                {p.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="mb-2">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={form.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>

                            <div className="mb-2">
                                <label className="form-label">Phone</label>
                                <input
                                    type="text"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                />
                            </div>

                            {/* <div className="mb-2">
                                <label className="form-label">
                                    Equity (%)
                                </label>
                                <input
                                    type="number"
                                    name="equity"
                                    value={form.equity}
                                    // onChange={handleChange}
                                    className="form-control"
                                    max={100}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (Number(value) <= 99) {
                                            setForm({ ...form, equity: value });
                                        }
                                    }}
                                    required
                                />
                            </div> */}
                            <div className="mb-2">
                                <label className="form-label">Equity (%)</label>

                                <input
                                    type="number"
                                    name="equity"
                                    value={form.equity}
                                    className="form-control"
                                    min="0"
                                    max={getRemainingParentEquity(form.parent_id)}
                                    onChange={(e) => {
                                        let value = Number(e.target.value);
                                        const maxAllowed = getRemainingParentEquity(form.parent_id);

                                        if (value < 0) value = 0;
                                        if (value > maxAllowed) {
                                            toast.warning(
                                                `Maximum allowed equity is ${maxAllowed}%`
                                            );
                                            value = maxAllowed;
                                        }

                                        setForm(prev => ({ ...prev, equity: value }));
                                    }}
                                    required
                                />

                                {form.parent_id && (
                                    <small className="text-muted">
                                        Remaining Parent Equity: {getRemainingParentEquity(form.parent_id)}%
                                    </small>
                                )}
                            </div>


                            <div className="mb-2">
                                <label className="form-label">
                                    Capital
                                </label>
                                <input
                                    type="number"
                                    name="capital"
                                    value={form.capital}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="mb-2">
                                <label className="form-label">
                                    Remarks
                                </label>
                                <textarea
                                    className="form-control"
                                    name="remarks"
                                    value={form.remarks}
                                    onChange={handleChange}
                                    rows="2"
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={closeModal}
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                {data ? "Update" : "Save"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddShareHolderForm;
